import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { isObjectModified } from '../../components/property-mapper';
import CompareField from './compare-field';

const LifeReview = ({title, planType, modifiedSelections, unmodifiedSelections, setIsModified}) => {
    const [modified, setModified] = useState();
    const [unmodified, setUnmodified] = useState();
    const enrollments = useSelector(s => s.enrollments);

    useEffect(() => {
        const m =modifiedSelections?.find(s => s.planType === planType);
        const u = unmodifiedSelections?.find(s => s.planType === planType);
        setModified(m);
        setUnmodified(u);
        if((m?.amount ?? null) !== (u?.amount ?? null))
            setIsModified(true);
    }, [enrollments, modifiedSelections, unmodifiedSelections]);


    return ( 
        <CompareField title={title} modifiedValue={modified?.amount} unmodifiedValue={unmodified?.amount} type="currency" />
     );
}
 
export default LifeReview;